import {
  PHOTO_COMMENT_EXAMPLE,
  PHOTO_COMMENT_LIST,
  PHOTO_IMAGE,
  PHOTO_RATING_NUM,
  PHOTO_TIME_NUM,
  PHOTO_TITLE,
} from "../constants"
import AuthorEntity from "./author-entity"
import CommentEntity from "./comment-entity"

class PhotoEntity {
  /**
   * Creates an instance of PhotoEntity.
   * @param {Object} settings
   * @param {Number} settings.id
   * @param {String} settings.title
   * @param {String} settings.description
   * @param {String} settings.url
   * @param {?Number} settings.timestamp
   * @param {Number} settings.stars
   * @param {AuthorEntity} settings.author
   * @param {CommentEntity[]} settings.comments
   * @memberof PhotoEntity
   */
  constructor({ id, title, description, url, timestamp, stars, author, comments }) {
    this.id = id
    this.title = title
    this.description = description
    this.url = url
    this.timestamp = timestamp
    this.stars = stars
    this.author = author
    this.comments = comments
  }

  /**
   * @param {Object} settings
   * @param {Number} settings.id
   * @param {String} settings.title
   * @param {String} settings.description
   * @param {String} settings.url
   * @param {?Number} settings.timestamp
   * @param {Number} settings.stars
   * @param {AuthorEntity} settings.author
   * @param {CommentEntity[]} settings.comments
   * @memberof PhotoEntity
   */
  copyWith({ id, title, description, url, timestamp, stars, author, comments }) {
    return new PhotoEntity({
      id: id === undefined ? this.id : id,
      title: title === undefined ? this.title : title,
      description: description === undefined ? this.description : description,
      url: url === undefined ? this.url : url,
      timestamp: timestamp === undefined ? this.timestamp : timestamp,
      stars: stars === undefined ? this.stars : stars,
      author: author === undefined ? this.author : author,
      comments: comments === undefined ? this.comments : comments,
    })
  }

  /**
   * @static
   * @param {object} json
   * @returns
   * @memberof PhotoEntity
   */
  static fromJson(json) {
    return new PhotoEntity({
      id: json.id,
      title: json.title,
      description: json.descr,
      url: json.url,
      timestamp: json.taken_at && Date.parse(json.taken_at),
      stars: json.num_stars,
      author: AuthorEntity.FromJson(json),
      comments: json.comments.map(CommentEntity.fromJson),
    })
  }

  /**
   * @static
   * @param {HTMLElement} htmlElement
   * @memberof PhotoEntity
   */
  static fromHtmlElement(htmlElement) {
    const imageElement = htmlElement.querySelector(PHOTO_IMAGE)
    const titleElement = htmlElement.querySelector(PHOTO_TITLE)
    const timestampElement = htmlElement.querySelector(PHOTO_TIME_NUM)
    const starsElement = htmlElement.querySelector(PHOTO_RATING_NUM)
    const commentListElement = htmlElement.querySelector(PHOTO_COMMENT_LIST)

    return new PhotoEntity({
      id: Number(imageElement.dataset.photoId),
      title: titleElement.textContent,
      description: "",
      url: imageElement.currentSrc || imageElement.src,
      timestamp:
        timestampElement.dataset.date === undefined ? null : Number(timestampElement.dataset.date),
      stars: Number(starsElement.textContent) || null,
      author: AuthorEntity.fromHtmlElement(htmlElement),
      comments: Array.from(
        commentListElement.querySelectorAll(`li:not(${PHOTO_COMMENT_EXAMPLE})`),
      ).map(CommentEntity.fromHtmlElement),
    })
  }
}

export default PhotoEntity
